import React, { useEffect, useState } from "react";
import "./Terms.scss"

const baseUrl = process.env.REACT_APP_ADMIN_PANEL_API || "https://devapi.credee.com/admin/";

const Terms = () => {
  const [termsData, setTermsData] = useState([]);
  useEffect(() => {
    
    getTerms();
    return () =>{
      localStorage.removeItem('terms')
    };
  }, []);
  const getTerms = async () => {
    let partner_storage: any = localStorage.getItem("partner_storage")
    partner_storage = (JSON.parse(partner_storage))
    const body = {
      template_name: "TERMS_CONDITION_PARTNER",
      type: 2,
      currency_id: partner_storage?.country_data && partner_storage?.country_data.currency && partner_storage?.country_data.currency[0]?.currency_id ? partner_storage?.country_data.currency[0]?.currency_id : 1,
      country_id: partner_storage?.country_data && partner_storage?.country_data.value ? partner_storage?.country_data.value  : 1,
    };
    await fetch(`${baseUrl}cms_details_for_panel`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((res) => {
        localStorage.setItem('terms', 'show');
        return res.json();
      })
      .then(async (res) => {
        // console.log(res.data, "yhuhuh");
        setTermsData(res.data);
      })
      .catch((error) => {
        console.error("There was a problem with the calculator params:", error);
      });
  };

  return (
    <div className="terms right-wrapper"
      dangerouslySetInnerHTML={{
        __html: (termsData && termsData[0] && termsData[0]["content"]) || "",
      }}
    ></div>
  );
};

export default Terms;
